import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TermsAndConditions from "./pages/TermsAndConditions";
import Feed from "./pages/Feed";
import Profile from "./pages/Profile";
import Company from "./pages/Company";
import Events from "./pages/Events";
import Messages from "./pages/Messages";
import Search from "./pages/Search";
import PostDetail from "./pages/PostDetail";
import CompanyDetail from "./pages/CompanyDetail";
import EventDetail from "./pages/EventDetail";

export const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/terms", element: <TermsAndConditions /> },
  {
    path: "/app",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/app/feed" replace /> },
      { path: "feed", element: <Feed /> },
      { path: "search", element: <Search /> },
      { path: "company", element: <Company /> },
      { path: "events", element: <Events /> },
      {
        path: "messages",
        element: (
          <ProtectedRoute requireAuth>
            <Messages />
          </ProtectedRoute>
        ),
      },
      { path: "profile/:username", element: <Profile /> },
      { path: "post/:id", element: <PostDetail /> },
      { path: "company/:id", element: <CompanyDetail /> },
      { path: "events/:id", element: <EventDetail /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
